import './intl-tel-input.css'
